export const addcompany = `
mutation AddCompany($input: CompanyInput!) {
  addCompany(input: $input) {
    success
    error
    message
  }
}
`
export const updatecompany =`
mutation UpdateCompany($id: Int!, $input: CompanyInput!) {
  updateCompany(id: $id, input: $input) {
    success
    error
    message
  }
}
`

export const verifyifsc = `
mutation VerifyIFSC($ifscCode: String!) {
  checkIfscCode(ifscCode: $ifscCode) {
    success
    error
    message
    data
  }
}

`
export const  deletecontactinfo = `
  mutation DeleteContact($id: Int!) {
  deleteContact(id: $id) {
    success
    error
    message
  }
}
`

export const deletecompany =`
mutation DeleteCompany($id: Int!) {
  deleteCompany(id: $id) {
    success
    error
    message
  }
}

`